import {
  RefinementListItem,
  RefinementListRenderState
} from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import { FycPromosContentFragment } from "types/graphql-types";
import { byConfigurationAlgoliaCode } from "src/utils/promos";
import { DescriptionForItem } from "components/FindYourCruise/Components/RefinementListFilter/RefinedListValues";
import { isPresent } from "src/utils/checks";

export const nameForItem =
  (content: FycPromosContentFragment[]) =>
  (items: RefinementListItem[]): RefinementListItem[] => {
    const transformedItems = [...items]
      .map((item) => {
        const algoliaCode = algoliaPromoValueToAlgoliaCode(item.value);
        const algoliaPromoCode = byConfigurationAlgoliaCode(algoliaCode);
        const promo = content?.find(algoliaPromoCode);
        const label = promo?.title?.localized;
        if (!label) return undefined;

        return {
          ...item,
          label
        };
      })
      .filter(isPresent)
      .sort((a, b) => a.label.localeCompare(b.label));
    return transformedItems;
  };

export const descriptionForItem =
  (content: FycPromosContentFragment[]) =>
  // eslint-disable-next-line react/display-name
  (
    item: RefinementListRenderState["items"][number]
  ): ReturnType<DescriptionForItem> => {
    const promo = content?.find(
      byConfigurationAlgoliaCode(algoliaPromoValueToAlgoliaCode(item.value))
    );
    if (!promo?.fycFilterDescription?.localized) return undefined;

    return promo.fycFilterDescription.localized;
  };

export const promosWithHideInFYCFlag = (
  content: FycPromosContentFragment[],
  items: RefinementListItem[]
) => {
  return items
    .filter((item) => {
      const algoliaCode = algoliaPromoValueToAlgoliaCode(item.value);
      const promo = content?.find(byConfigurationAlgoliaCode(algoliaCode));
      return promo?.hideInFYCOfferFilter === true;
    })
    .map((item) => algoliaPromoValueToAlgoliaCode(item.value));
};

export const excludePromosByConfigurationCodes =
  (exclude: number[]) => (items: RefinementListItem[]) =>
    items.filter(
      (item) => !exclude.includes(algoliaPromoValueToAlgoliaCode(item.value))
    );

export const algoliaPromoValueToAlgoliaCode = (algoliaCode: string) => {
  const code = parseInt(algoliaCode, 10);
  return isNaN(code) ? -1 : code;
};

export const toPromoAlgoliaCodeMapping = (
  promosContent: FycPromosContentFragment[]
) => {
  return promosContent.reduce(
    (acc, promo) => {
      const promoCode = promo.configuration?.code;
      const algoliaCode = promo.configuration?.algoliaCode;
      if (promoCode && algoliaCode) {
        acc[promoCode] = algoliaCode;
      }
      return acc;
    },
    {} as Record<string, number>
  );
};
